import { Routes } from '@angular/router';
import { ErrorHandlingComponent } from './views/error-handling/error-handling.component';
import { SidenavComponent } from './layouts/sidenav/sidenav.component';

export const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'risk',
                loadChildren: () =>
                    import('./views/risk/risk.routes').then(
                        (m) => m.RISK_ROUTES,
                    ),
            },
            {
                path: 'customer',
                loadChildren: () =>
                    import('./views/customer/customer.routes').then(
                        (m) => m.CUSTOMER_ROUTES,
                    ),
            },
            {
                path: 'marketplace',
                loadChildren: () =>
                    import('./views/marketplace/marketplace.routes').then(
                        (m) => m.MARKETPLACE_ROUTES,
                    ),
            },
            {
                path: 'payment',
                loadChildren: () =>
                    import('./views/payment/payments.routes').then(
                        (m) => m.PAYMENTS_ROUTES,
                    ),
            },
            {
                path: 'configuration',
                loadChildren: () =>
                    import('./views/configuration/configuration.routes').then(
                        (m) => m.CONFIGURATION_ROUTES,
                    ),
            },
            {
                path: 'calling',
                loadChildren: () =>
                    import('./views/calling/calling.routes').then(
                        (m) => m.CALLING_ROUTES,
                    ),
            },
            {
                path: 'users',
                loadChildren: () =>
                    import('./views/users/users.routes').then(
                        (m) => m.USERS_ROUTES,
                    ),
            },
            {
                path: 'subscription',
                loadChildren: () =>
                    import('./views/subscription/subscription.routes').then(
                        (m) => m.SUBSCRIPTION_ROUTES,
                    ),
            },
            { path: 'error/auth', component: ErrorHandlingComponent },
        ],
        component: SidenavComponent,
    },
];
